import interceptor from '@/plugins/interceptor';
const pathController = '/Stuff'

export default {
    state: () => ({
    
    }),
    mutations: { 
    },
    actions: {
        async stuff_organizationsByCountryId (_,model) {
            const ret = await interceptor.authenticate.get(`${process.env.VUE_APP_API_BACKOFFICE_URL}${pathController}/organizations?countryId=${model.countryId}`);
            return ret.data;
        },
        async stuff_getCountries(){
            const ret = await interceptor.authenticate.get(`${process.env.VUE_APP_API_BACKOFFICE_URL}${pathController}/countries`);
            return ret.data;
        },
        async stuff_getOrganizations(){
            const ret = await interceptor.authenticate.get(`${process.env.VUE_APP_API_BACKOFFICE_URL}${pathController}/organizations`);
            return ret.data;
        }
    }
}

